module.exports = __webpack_public_path__ + "static/media/dropdowngroup.056e9616.png";